

  <div class="header">
    <a href="index.html" class="logo"><img class="img-l" src="./assets/img/Pan_American_Energy_logo.svg.png" alt=""></a>
  </div>
  <!--<div class="container ">
    <img src="./assets/img/pae mapa orientativo .png">
  </div>-->
